var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "field" },
    [
      _vm.label
        ? _c("label", { staticClass: "label" }, [_vm._v(_vm._s(_vm.label))])
        : _vm._e(),
      _c(
        "div",
        { staticClass: "control", class: { "has-icons-left": _vm.hasIcon } },
        [
          _c(
            "money",
            _vm._b(
              {
                staticClass: "input",
                class: { "is-danger": _vm.showError },
                attrs: { disabled: _vm.disabled, "data-test": _vm.name },
                on: { input: _vm.input, blur: _vm.blur, focus: _vm.focus },
                model: {
                  value: _vm.price,
                  callback: function ($$v) {
                    _vm.price = $$v
                  },
                  expression: "price",
                },
              },
              "money",
              _vm.money,
              false
            )
          ),
          _vm.hasIcon
            ? _c(
                "span",
                { staticClass: "icon is-left" },
                [
                  _c("dc-icon", {
                    staticClass: "currency",
                    attrs: { icon: _vm.icon },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm.showError
        ? _c(
            "p",
            {
              staticClass: "help is-danger",
              attrs: { "data-test": "error-" + _vm.name },
            },
            [_vm._v(" " + _vm._s(_vm.error) + " ")]
          )
        : _vm._e(),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }